function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/isNativeReflectConstruct.js
// module id = 40
// module chunks = 0